module.exports = __webpack_public_path__ + "img/motorway_4x4_z18.47cd9360.svg";